export const PageType = {
  PUBLIC: 'PUBLIC',
  PUBLIC_SLA: 'PUBLIC_SLA',
  INTERNAL: 'INTERNAL',
};
